import { render, staticRenderFns } from "./CalendarConfiguration.vue?vue&type=template&id=4651b6bc&scoped=true"
import script from "./CalendarConfiguration.vue?vue&type=script&lang=js"
export * from "./CalendarConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651b6bc",
  null
  
)

export default component.exports